import ScenarioUtils from "../utils/scenarioUtils";

export default function RoleString(props: { raw_scenario: string[], short?: boolean }) {
    const {raw_scenario, short} = props; 
    const roleSetup = ScenarioUtils.CalculateRoleSetup(props.raw_scenario);

    const townLabel= short=== true ? '' : ' town';
    const mafiaLabel= short=== true ? '' : ' mafia';
    const neutralLabel= short=== true ? '' : ' other';
    const mixedLabel= short=== true ? '' : ' ?';

    return <div>
        <span className="town">{`${roleSetup.town}${townLabel}`}</span>+
        <span className="mafia">{`${roleSetup.mafia}${mafiaLabel}`}</span>+
        <span className="neutral">{`${roleSetup.neutral}${neutralLabel}`}</span>+
        <span className="mixed">{`${roleSetup.mixed}${mixedLabel}`}</span>=
        <span className='mark'>{raw_scenario.length}</span>
    </div>

}